import {
  MapProposalAction,
  MapProposalArtifact,
  ProposalEdge,
} from '@trustero/trustero-api-web/lib/artifact/artifact_pb'

/** An ADD or a REMOVE. A KEEP is a link already in place, not a change. */
export const isProposalChange = (e: ProposalEdge): boolean => {
  const a = e.getRecommendedAction()
  return (
    a === MapProposalAction.MAP_PROPOSAL_ACTION_ADD ||
    a === MapProposalAction.MAP_PROPOSAL_ACTION_REMOVE
  )
}

export interface ProposalChangeCounts {
  changes: number
  /** Sources (controls) with at least one change. */
  changedSources: number
  alreadyLinked: number
}

export const countProposalChanges = (
  proposal: MapProposalArtifact,
): ProposalChangeCounts => {
  const changedSources = new Set<string>()
  let changes = 0
  let alreadyLinked = 0
  proposal.getEdgesList().forEach((e) => {
    if (isProposalChange(e)) {
      changes += 1
      changedSources.add(e.getSourceId())
    } else if (
      e.getRecommendedAction() === MapProposalAction.MAP_PROPOSAL_ACTION_KEEP
    ) {
      alreadyLinked += 1
    }
  })
  return { changes, changedSources: changedSources.size, alreadyLinked }
}
